import {
  ROMANIA_DESCRIPTION_LIST_FAIL,
  ROMANIA_DESCRIPTION_LIST_REQUEST,
  ROMANIA_DESCRIPTION_LIST_SUCCESS,
  ROMANIA_DESCRIPTION_UPDATE_FAIL,
  ROMANIA_DESCRIPTION_UPDATE_REQUEST,
  ROMANIA_DESCRIPTION_UPDATE_RESET,
  ROMANIA_DESCRIPTION_UPDATE_SUCCESS,
} from "../constants/aboutRomaniaConstant";

export const listRomaniaDescriptionReducer = (state = {}, action) => {
  switch (action.type) {
    case ROMANIA_DESCRIPTION_LIST_REQUEST:
      return {
        loading: true,
      };
    case ROMANIA_DESCRIPTION_LIST_SUCCESS:
      return {
        loading: false,
        success: true,
        descriptions: action.payload,
      };

    case ROMANIA_DESCRIPTION_LIST_FAIL:
      return {
        loading: true,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const romaniaDescriptionEditReducer = (state = {}, action) => {
  switch (action.type) {
    case ROMANIA_DESCRIPTION_UPDATE_REQUEST:
      return {
        loading: true,
      };
    case ROMANIA_DESCRIPTION_UPDATE_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case ROMANIA_DESCRIPTION_UPDATE_FAIL:
      return {
        loading: true,
        error: action.payload,
      };
    case ROMANIA_DESCRIPTION_UPDATE_RESET:
      return {
        loading: true,
        success: false,
      };
    default:
      return state;
  }
};
